import { getDateTime } from '../../../utilities'
import { IPulsaraAttachmentItem, IPulsaraAttachmentStored } from '../store/pulsara.types'

export const formatAttachments = (
  attachmentsNotAlreadyOnPcr: Array<IPulsaraAttachmentItem>
): Array<IPulsaraAttachmentStored> => {
  return attachmentsNotAlreadyOnPcr.map((att: IPulsaraAttachmentItem) => {
    const fileExtension =
      typeof att.name === 'string' && att.name.includes('.') ? att.name.split('.').pop()?.toLowerCase() ?? '' : ''
    return {
      id: att.id,
      name: att.name,
      category: att.category,
      mime: att.mime,
      size: null,
      fileExtension,
      pulsaraId: att.pulsaraId,
      uploadedDt: getDateTime(),
    }
  })
}
